// AdminPanel.js - Responsive Owner Admin Panel
import React, { useState, useEffect } from 'react';

const AP_CSS = `
  .ap-panel {
    width: 100%;
    max-width: 1100px;
    max-height: calc(100dvh - 2rem);
    overflow-y: auto;
    background: #0f1923;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 16px;
    scrollbar-width: thin;
    scrollbar-color: rgba(0,212,255,0.15) transparent;
  }
  .ap-panel::-webkit-scrollbar { width: 4px; }
  .ap-panel::-webkit-scrollbar-thumb { background: rgba(0,212,255,0.2); border-radius: 2px; }

  .ap-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    position: sticky;
    top: 0;
    background: #0f1923;
    z-index: 10;
  }

  .ap-stats-section {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }

  .ap-stats-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.6rem;
  }
  @media (min-width: 480px) { .ap-stats-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (min-width: 768px) { .ap-stats-grid { grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); } }

  .ap-tabs {
    display: flex;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0 1.25rem;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    gap: 0;
  }
  .ap-tabs::-webkit-scrollbar { display: none; }

  .ap-tab {
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    padding: 0.75rem 0.9rem;
    font-weight: 600;
    font-size: 0.82rem;
    white-space: nowrap;
    color: #8892a4;
    transition: color 0.15s;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    flex-shrink: 0;
    font-family: inherit;
  }
  .ap-tab:hover { color: #c0cad8; }
  .ap-tab.ap-active { color: #00d4ff; border-bottom-color: #00d4ff; }

  .ap-content { padding: 1rem 1.25rem; }

  .ap-user-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    padding: 0.85rem 1rem;
    transition: border-color 0.15s;
  }
  .ap-user-card:hover { border-color: rgba(255,255,255,0.15); }

  .ap-card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  }
  @media (max-width: 479px) {
    .ap-card-row { flex-direction: column; align-items: flex-start; }
    .ap-user-actions { width: 100%; }
    .ap-pending-actions { width: 100%; }
  }

  .ap-user-actions {
    display: flex;
    gap: 0.4rem;
    flex-wrap: wrap;
    flex-shrink: 0;
  }
  .ap-pending-actions {
    display: flex;
    gap: 0.4rem;
    flex-shrink: 0;
  }

  .ap-lockdown-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  @media (min-width: 480px) { .ap-lockdown-grid { grid-template-columns: 1fr 1fr; } }

  .ap-form-grid-2 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  @media (min-width: 480px) { .ap-form-grid-2 { grid-template-columns: 1fr 1fr; } }

  .ap-input {
    width: 100%;
    padding: 7px 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 6px;
    color: #f0f2f5;
    font-size: 13px;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.15s;
    font-family: inherit;
  }
  .ap-input:focus { border-color: rgba(0,212,255,0.4); }
  .ap-input--danger { border-color: rgba(239,68,68,0.15); }
  .ap-input--danger:focus { border-color: rgba(239,68,68,0.4); }

  .ap-modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.88);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
    padding: 1rem;
    box-sizing: border-box;
  }
  .ap-modal-box {
    background: #0f1923;
    border-radius: 14px;
    padding: 1.5rem;
    width: 100%;
    box-sizing: border-box;
  }

  .ap-btn {
    border: none;
    border-radius: 7px;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.78rem;
    padding: 0.4rem 0.75rem;
    transition: opacity 0.15s, transform 0.1s;
    white-space: nowrap;
    font-family: inherit;
  }
  .ap-btn:hover:not(:disabled) { opacity: 0.8; }
  .ap-btn:active:not(:disabled) { transform: scale(0.97); }
  .ap-btn:disabled { opacity: 0.45; cursor: not-allowed; }
  .ap-btn--green  { background: #16a34a; color: #fff; }
  .ap-btn--red    { background: #dc2626; color: #fff; }
  .ap-btn--blue   { background: rgba(0,212,255,0.15); color: #00d4ff; border: 1px solid rgba(0,212,255,0.3); }
  .ap-btn--ghost  { background: rgba(255,255,255,0.08); color: #ccc; }
  .ap-btn--full   { width: 100%; padding: 0.6rem; text-align: center; }

  .ap-maint-btn {
    padding: 7px 14px;
    background: rgba(59,130,246,0.1);
    border: 1px solid rgba(59,130,246,0.35);
    border-radius: 6px;
    color: #3B82F6;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    transition: opacity 0.15s;
  }
  .ap-maint-btn:hover:not(:disabled) { opacity: 0.8; }
  .ap-maint-btn:disabled { opacity: 0.45; cursor: not-allowed; }

  .ap-maint-btn--cancel {
    padding: 7px 14px;
    background: rgba(239,68,68,0.1);
    border: 1px solid rgba(239,68,68,0.35);
    border-radius: 6px;
    color: #ef4444;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    transition: opacity 0.15s;
  }
  .ap-maint-btn--cancel:hover:not(:disabled) { opacity: 0.8; }
  .ap-maint-btn--cancel:disabled { opacity: 0.45; cursor: not-allowed; }

  .ap-maint-btn--ghost {
    padding: 7px 14px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    color: #8b95a8;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    transition: opacity 0.15s;
  }
  .ap-maint-btn--ghost:hover:not(:disabled) { opacity: 0.8; }

  .ap-section-box {
    background: rgba(22,27,39,0.7);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    padding: 1.25rem;
  }

  .ap-pending-card {
    background: rgba(251,191,36,0.04);
    border: 1px solid rgba(251,191,36,0.2);
    border-radius: 10px;
    padding: 0.85rem 1rem;
  }

  .ap-report-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,80,80,0.15);
    border-radius: 10px;
    padding: 0.85rem 1rem;
  }

  .ap-lockdown-btns {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .ap-withdrawal-detail-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 0.4rem 1rem;
    margin-bottom: 0.75rem;
  }
  @media (max-width: 479px) {
    .ap-withdrawal-detail-grid { grid-template-columns: 1fr 1fr; }
  }

  @media (max-width: 380px) {
    .ap-header, .ap-stats-section, .ap-content { padding: 0.85rem 0.9rem; }
    .ap-tabs { padding: 0 0.9rem; }
  }
`;

function AdminPanel({ token, onClose }) {
  const [activeTab, setActiveTab] = useState('users');
  const [stats, setStats] = useState(null);
  const [toast, setToast] = useState(null);
  const [pendingUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userFilter, setUserFilter] = useState('all');
  const [editStorageModal, setEditStorageModal] = useState(null);
  const [newStorageLimit, setNewStorageLimit] = useState('');
  const [confirmModal, setConfirmModal] = useState(null);
  const [rejectWithdrawalModal, setRejectWithdrawalModal] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(null);
  const [lockdownStatus, setLockdownStatus] = useState(null);
  const [lockdownLoading, setLockdownLoading] = useState(false);
  const [maintenanceForm, setMaintenanceForm] = useState({ message: '', end: '', banner: '', banner_active: false, scheduled_start: '', scheduled_end: '' });
  const [lockdownForm, setLockdownForm] = useState({ message: '', end: '' });
  const [broadcastForm, setBroadcastForm] = useState({ subject: '', category: 'announcement', date: new Date().toISOString().split('T')[0], effectiveDate: '', body: '' });
  const [broadcastSending, setBroadcastSending] = useState(false);
  const [broadcastResult, setBroadcastResult] = useState(null);
  const [broadcastConfirm, setBroadcastConfirm] = useState(false);
  const [userDetailModal, setUserDetailModal] = useState(null);
  const [userDetailAddrForm, setUserDetailAddrForm] = useState({});
  const [userDetailAddrEdit, setUserDetailAddrEdit] = useState(false);
  const [userDetailAddrSaving, setUserDetailAddrSaving] = useState(false);
  const [userDetailAddrMsg, setUserDetailAddrMsg] = useState('');
  const [reset2FaMsg, setReset2FaMsg] = useState('');
  const [reset2FaSaving, setReset2FaSaving] = useState(false);

  useEffect(() => {
    if (document.getElementById('ap-styles')) return;
    const el = document.createElement('style');
    el.id = 'ap-styles';
    el.textContent = AP_CSS;
    document.head.appendChild(el);
    return () => { el.remove(); };
  }, []);

  const showToast = (msg, type = 'info') => {
    setToast({ message: msg, type });
    setTimeout(() => setToast(null), 4000);
  };

  useEffect(() => {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    };
  }, []);

  useEffect(() => {
    loadStats();
    loadAllUsers();
    setLoading(false);
  }, []);

  useEffect(() => {
    if (activeTab === 'users') loadAllUsers();
    if (activeTab === 'withdrawals') loadWithdrawals();
    if (activeTab === 'reports') loadReports();
    if (activeTab === 'lockdown') loadLockdownStatus();
  }, [activeTab, userFilter]);

  const loadStats = async () => {
    try {
      const r = await fetch('/api/admin/stats', { headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      setStats(await r.json());
    } catch { console.error('Load stats error'); }
  };


  const loadAllUsers = async () => {
    try {
      const r = await fetch(`/api/admin/users?status=${userFilter}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setAllUsers(d.users || []);
    } catch { console.error('Load users error'); }
  };

  const loadWithdrawals = async () => {
    try {
      const r = await fetch('/api/admin/withdrawals', { headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setWithdrawals(d.withdrawals || []);
    } catch { console.error('Load withdrawals error'); }
  };

  const loadReports = async () => {
    try {
      const r = await fetch('/api/admin/reports', { headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setReports(d.reports || []);
    } catch { console.error('Load reports error'); }
  };

  const loadLockdownStatus = async () => {
    try {
      const r = await fetch('/api/admin/lockdown/status', { headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setLockdownStatus(d.status);
    } catch { console.error('Load lockdown status error'); }
  };

  // ── Maintenance handlers — all check HTTP status now ──

  const handleMaintenanceStart = async () => {
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/maintenance', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: true, message: maintenanceForm.message, end: maintenanceForm.end ? new Date(maintenanceForm.end).toISOString() : null, banner: maintenanceForm.banner, banner_active: maintenanceForm.banner_active }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('Wartungsmodus aktiviert', 'success');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };

  const handleMaintenanceStop = async () => {
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/maintenance', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: false }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('Wartungsmodus beendet', 'success');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };

  const handleMaintenanceSchedule = async () => {
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/maintenance', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: maintenanceForm.message,
          banner: maintenanceForm.banner,
          banner_active: maintenanceForm.banner_active,
          scheduled_start: maintenanceForm.scheduled_start ? new Date(maintenanceForm.scheduled_start).toISOString() : null,
          scheduled_end: maintenanceForm.scheduled_end ? new Date(maintenanceForm.scheduled_end).toISOString() : null,
        }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('Wartung geplant', 'success');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };

  const handleCancelScheduledMaintenance = async () => {
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/maintenance', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ cancel_scheduled: true }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('Geplante Wartung gelöscht', 'success');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };

  const handleBannerUpdate = async () => {
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/maintenance', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ banner: maintenanceForm.banner, banner_active: maintenanceForm.banner_active }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('Banner aktualisiert', 'success');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };

  const handleLockdownStart = async () => {
    if (!window.confirm('System-Lockdown aktivieren? Alle User werden sofort gesperrt.')) return;
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/system', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: true, message: lockdownForm.message, end: lockdownForm.end || null }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('System-Lockdown aktiviert', 'error');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };

  const handleLockdownStop = async () => {
    setLockdownLoading(true);
    try {
      const r = await fetch('/api/admin/lockdown/system', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: false }),
      });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Server-Fehler'); }
      await loadLockdownStatus();
      showToast('System-Lockdown beendet', 'success');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
    setLockdownLoading(false);
  };


  const openUserDetail = async (userId) => {
    try {
      const r = await fetch(`/api/admin/users/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      setUserDetailModal(d.user);
      setUserDetailAddrForm({
        billing_firstname: d.user.billing_firstname || '',
        billing_lastname:  d.user.billing_lastname  || '',
        billing_street:    d.user.billing_street    || '',
        billing_zip:       d.user.billing_zip       || '',
        billing_city:      d.user.billing_city      || '',
        billing_country:   d.user.billing_country   || 'DE',
      });
      setUserDetailAddrEdit(false);
      setUserDetailAddrMsg('');
      setReset2FaMsg('');
    } catch (e) { showToast('Fehler: ' + e.message, 'error'); }
  };

  const saveUserBillingAddress = async () => {
    setUserDetailAddrSaving(true);
    setUserDetailAddrMsg('');
    try {
      const r = await fetch(`/api/admin/users/${userDetailModal.id}/billing-address`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(userDetailAddrForm),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      setUserDetailModal(m => ({ ...m, ...userDetailAddrForm, billing_address_set: 1 }));
      setUserDetailAddrEdit(false);
      setUserDetailAddrMsg('ok:Adresse gespeichert.');
    } catch (e) { setUserDetailAddrMsg('err:' + e.message); }
    setUserDetailAddrSaving(false);
  };

  const resetUser2FA = async () => {
    setReset2FaSaving(true);
    setReset2FaMsg('');
    try {
      const r = await fetch(`/api/admin/users/${userDetailModal.id}/reset-2fa`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      setReset2FaMsg('ok:2FA erfolgreich zurückgesetzt.');
    } catch (e) { setReset2FaMsg('err:' + e.message); }
    setReset2FaSaving(false);
  };

  const doBlock = async (userId) => {
    try {
      const r = await fetch(`/api/admin/block/${userId}`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      showToast('Benutzer gesperrt!', 'success');
      loadStats(); loadAllUsers();
    } catch (e) { showToast('Fehler: ' + e.message); }
  };

  const doUnblock = async (userId) => {
    try {
      const r = await fetch(`/api/admin/unblock/${userId}`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      showToast('Benutzer entsperrt!', 'success');
      loadStats(); loadAllUsers();
    } catch (e) { showToast('Fehler: ' + e.message); }
  };

  const doDeleteUser = async (userId) => {
    try {
      const r = await fetch(`/api/admin/users/${userId}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      showToast('Benutzer gelöscht!', 'success');
      loadStats(); loadAllUsers();
    } catch { showToast('Fehler beim Löschen'); }
  };

  const handleUpdateStorage = async (userId) => {
    const bytes = parseFloat(newStorageLimit) * 1024 * 1024 * 1024;
    if (!newStorageLimit || bytes <= 0) { showToast('Bitte gültiges Speicherlimit eingeben'); return; }
    try {
      const r = await fetch(`/api/admin/update-storage/${userId}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ storage_limit: bytes }),
      });
      if (!r.ok) throw new Error();
      showToast('Speicherlimit aktualisiert!', 'success');
      setEditStorageModal(null); setNewStorageLimit('');
      loadAllUsers(); loadStats();
    } catch { showToast('Fehler beim Aktualisieren'); }
  };

  const handleApproveWithdrawal = async (id) => {
    try {
      const r = await fetch(`/api/admin/withdrawals/${id}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'approved' }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      showToast('Widerruf genehmigt! Erstattung + E-Mail ausgelöst.', 'success');
      loadWithdrawals();
    } catch (e) { showToast('Fehler: ' + e.message); }
  };

  const handleRejectWithdrawal = async (id, note) => {
    try {
      const r = await fetch(`/api/admin/withdrawals/${id}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'rejected', admin_note: note || '' }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Fehler');
      showToast('Widerruf abgelehnt. E-Mail an User gesendet.', 'success');
      setRejectWithdrawalModal(null);
      loadWithdrawals();
    } catch (e) { showToast('Fehler: ' + e.message); }
  };

  const handleBlockReport = async (id) => {
    try {
      const r = await fetch(`/api/admin/reports/${id}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'resolved' }),
      });
      if (!r.ok) throw new Error();
      showToast('Link gesperrt!', 'success');
      loadReports();
    } catch { showToast('Fehler beim Sperren'); }
  };

  const handleDismissReport = async (id) => {
    try {
      const r = await fetch(`/api/admin/reports/${id}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'rejected' }),
      });
      if (!r.ok) throw new Error();
      showToast('Meldung abgelehnt.', 'success');
      loadReports();
    } catch { showToast('Fehler beim Ablehnen'); }
  };

  const handleFilePreview = async (fileId, filename) => {
    const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    if (isMobile) {
      const url = `/api/admin/file-preview/${fileId}?token=${encodeURIComponent(token)}`;
      const a = document.createElement('a');
      a.href = url; a.target = '_blank'; a.rel = 'noopener noreferrer';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      return;
    }
    setPreviewLoading(fileId);
    try {
      const r = await fetch(`/api/admin/file-preview/${fileId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Preview fehlgeschlagen'); }
      const blob = await r.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename || 'preview';
      document.body.appendChild(a); a.click();
      window.URL.revokeObjectURL(url); document.body.removeChild(a);
    } catch (e) { showToast('Fehler: ' + e.message); }
    finally { setPreviewLoading(null); }
  };

  // ── Helpers ──

  const formatBytes = (bytes) => {
    if (!bytes || bytes === 0 || isNaN(bytes)) return '0 B';
    const k = 1024, sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
  };

  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const statusBadge = (status, labels) => {
    const colors = {
      pending:  { bg: 'rgba(251,191,36,0.15)',  color: '#fbbf24', border: 'rgba(251,191,36,0.3)'  },
      approved: { bg: 'rgba(74,222,128,0.15)',  color: '#4ade80', border: 'rgba(74,222,128,0.3)'  },
      blocked:  { bg: 'rgba(248,113,113,0.15)', color: '#f87171', border: 'rgba(248,113,113,0.3)' },
      rejected: { bg: 'rgba(248,113,113,0.15)', color: '#f87171', border: 'rgba(248,113,113,0.3)' },
      open:     { bg: 'rgba(251,191,36,0.15)',  color: '#fbbf24', border: 'rgba(251,191,36,0.3)'  },
    };
    const c = colors[status] || colors.pending;
    return (
      <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '20px', fontSize: '0.7rem', fontWeight: 700, background: c.bg, color: c.color, border: `1px solid ${c.border}`, whiteSpace: 'nowrap' }}>
        {labels[status] || status}
      </span>
    );
  };

  const userStatusBadge      = (s) => statusBadge(s, { pending: 'Ausstehend', approved: 'Freigegeben', blocked: 'Gesperrt' });
  const withdrawalStatusBadge = (s) => statusBadge(s, { pending: 'Ausstehend', approved: 'Genehmigt', rejected: 'Abgelehnt' });
  const reportStatusBadge    = (s) => statusBadge(s, { open: 'Offen', blocked: 'Gesperrt', rejected: 'Abgelehnt' });

  const tabs = [
    { id: 'users',       label: 'Benutzer' },
    { id: 'withdrawals', label: 'Widerrufe' },
    { id: 'reports',     label: 'Meldungen' },
    { id: 'lockdown',    label: '🔒 Lockdown' },
    { id: 'broadcast',   label: '📧 E-Mail' },
  ];

  if (loading) {
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(8px)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '3px solid rgba(0,212,255,0.2)', borderTop: '3px solid #00d4ff', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 1rem' }} />
          <p style={{ color: '#8892a4', fontSize: '0.9rem' }}>Lade Admin Panel…</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(8px)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', boxSizing: 'border-box' }}>

      {/* Toast */}
      {toast && (
        <div onClick={() => setToast(null)} style={{
          position: 'fixed', top: '1rem', left: '50%', transform: 'translateX(-50%)',
          zIndex: 10000, maxWidth: '420px', width: 'calc(100% - 2rem)', padding: '0.7rem 1rem',
          background: toast.type === 'success' ? 'rgba(74,222,128,0.15)' : 'rgba(255,80,80,0.15)',
          border: '1px solid ' + (toast.type === 'success' ? 'rgba(74,222,128,0.3)' : 'rgba(255,80,80,0.3)'),
          borderRadius: '10px', color: toast.type === 'success' ? '#4ade80' : '#ff8888',
          fontSize: '0.82rem', cursor: 'pointer', backdropFilter: 'blur(12px)',
          textAlign: 'center', fontWeight: 600,
        }}>{toast.message}</div>
      )}

      {/* Panel */}
      <div className="ap-panel">

        {/* Header */}
        <div className="ap-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <div style={{ width: '32px', height: '32px', background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', flexShrink: 0 }}>⚙</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '1rem', color: '#fff' }}>Admin Panel</div>
              <div style={{ fontSize: '0.65rem', color: '#8892a4', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Owner Dashboard</div>
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#8892a4', cursor: 'pointer', fontSize: '1.3rem', padding: '0.25rem', lineHeight: 1, flexShrink: 0 }}>✕</button>
        </div>

        {/* Stats */}
        {stats && (
          <div className="ap-stats-section">
            <div className="ap-stats-grid">
              {[
                { label: 'Benutzer',          value: stats.total_users,                            color: '#00d4ff' },
                { label: 'Dateien',            value: stats.total_files,                            color: '#a78bfa' },
                { label: 'Speicher (DB)',      value: formatBytes(stats.total_storage),             color: '#fff'    },
                { label: 'Disk (Encrypted)',   value: formatBytes(stats.disk_storage_bytes),        color: '#4ade80' },
                { label: 'Dateien (Disk)',     value: stats.disk_file_count ?? '–',                 color: '#60a5fa' },
              ].map(s => (
                <div key={s.label} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '10px', padding: '0.75rem' }}>
                  <div style={{ fontSize: '0.63rem', color: '#8892a4', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.35rem' }}>{s.label}</div>
                  <div style={{ fontWeight: 800, fontSize: '1.15rem', color: s.color }}>{s.value}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="ap-tabs">
          {tabs.map(t => (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`ap-tab${activeTab === t.id ? ' ap-active' : ''}`}
            >
              {t.label}
              {t.badge && (
                <span style={{ background: '#fbbf24', color: '#000', borderRadius: '20px', fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px' }}>{t.badge}</span>
              )}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="ap-content">

          {/* ── Tab: Benutzer ── */}
          {activeTab === 'users' && (
            <div>
              <div style={{ display: 'flex', gap: '0.4rem', marginBottom: '0.85rem', flexWrap: 'wrap' }}>
                {[['all', 'Alle'], ['approved', 'Freigegeben'], ['blocked', 'Gesperrt']].map(([val, label]) => (
                  <button
                    key={val}
                    onClick={() => setUserFilter(val)}
                    className="ap-btn"
                    style={{
                      background: userFilter === val ? 'rgba(0,212,255,0.15)' : 'rgba(255,255,255,0.06)',
                      color: userFilter === val ? '#00d4ff' : '#8892a4',
                      border: userFilter === val ? '1px solid rgba(0,212,255,0.3)' : '1px solid rgba(255,255,255,0.08)',
                    }}
                  >{label}</button>
                ))}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {allUsers.map(user => (
                  <div key={user.id} className="ap-user-card">
                    <div className="ap-card-row">
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: 1, minWidth: 0 }}>
                        <img
                          src={user.avatar ? `https://cdn.discordapp.com/avatars/${user.discord_id}/${user.avatar}.png` : '/default-avatar.png'}
                          alt={user.username}
                          style={{ width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0 }}
                        />
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.3rem', flexWrap: 'wrap' }}>
                            <span style={{ fontWeight: 700, color: '#fff', fontSize: '0.88rem' }}>{user.username}</span>
                            {userStatusBadge(user.status)}
                            {user.is_owner && (
                              <span style={{ background: 'rgba(167,139,250,0.2)', color: '#a78bfa', border: '1px solid rgba(167,139,250,0.3)', borderRadius: '20px', fontSize: '0.65rem', fontWeight: 700, padding: '2px 7px' }}>OWNER</span>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '0.75rem', fontSize: '0.7rem', color: '#8892a4', flexWrap: 'wrap' }}>
                            <span>{user.email || 'Keine E-Mail'}</span>
                            <span>{user.file_count} Dateien</span>
                            <span>{formatBytes(user.total_storage)}</span>
                            <span>Limit: {formatBytes(user.storage_limit)}</span>
                            {user.total_compressed_storage > 0 && <span style={{ color: '#4ade80' }}>{formatBytes(user.total_compressed_storage)} auf Server</span>}
                            <span>{formatDate(user.last_login)}</span>
                          </div>
                        </div>
                      </div>
                      <div className="ap-user-actions">
                        <button onClick={() => openUserDetail(user.id)} className="ap-btn" title="Benutzerdetails" style={{ background: 'rgba(255,255,255,0.06)', color: '#c0cad8', border: '1px solid rgba(255,255,255,0.1)' }}>ℹ</button>
                        <button onClick={() => { setEditStorageModal(user); setNewStorageLimit((user.storage_limit / (1024 * 1024 * 1024)).toFixed(2)); }} className="ap-btn ap-btn--blue" title="Speicher anpassen">💾</button>
                        {!user.is_owner && (user.status === 'blocked' ? (
                          <button onClick={() => setConfirmModal({ action: 'unblock', userId: user.id, message: 'Benutzer wirklich entsperren?' })} className="ap-btn ap-btn--green">Entsperren</button>
                        ) : (
                          <button onClick={() => setConfirmModal({ action: 'block', userId: user.id, message: 'Benutzer wirklich sperren?' })} className="ap-btn ap-btn--ghost">Sperren</button>
                        ))}
                        {!user.is_owner && (
                          <button onClick={() => setConfirmModal({ action: 'delete', userId: user.id, message: `User "${user.username}" und ALLE Dateien endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden!` })} className="ap-btn ap-btn--red">Löschen</button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                {allUsers.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '2rem 0', color: '#8892a4', fontSize: '0.9rem' }}>Keine Benutzer gefunden</div>
                )}
              </div>
            </div>
          )}

          {/* ── Tab: Widerrufe ── */}
          {activeTab === 'withdrawals' && (
            <div>
              {withdrawals.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem 0', color: '#8892a4', fontSize: '0.9rem' }}>Keine Widerrufe vorhanden</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {withdrawals.map(w => {
                    const isPending = w.status === 'received' || w.status === 'pending' || !w.status;
                    const storageUsedPct = w.storage_limit ? Math.round((w.storage_used / w.storage_limit) * 100) : 0;
                    return (
                      <div key={w.id} style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${isPending ? 'rgba(251,191,36,0.25)' : 'rgba(255,255,255,0.08)'}`, borderRadius: '12px', padding: '1rem 1.1rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.65rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                            <span style={{ fontWeight: 700, color: '#fff', fontSize: '0.92rem' }}>{w.username || '—'}</span>
                            {withdrawalStatusBadge(w.status === 'received' ? 'pending' : (w.status || 'pending'))}
                          </div>
                          <span style={{ fontSize: '0.72rem', color: '#8892a4' }}>{formatDate(w.received_at || w.created_at)}</span>
                        </div>
                        <div className="ap-withdrawal-detail-grid">
                          {[
                            { label: 'E-Mail',         value: w.email || w.user_email || '—' },
                            { label: 'Vertragsref.',   value: w.contract_ref || '—' },
                            { label: 'Abo-Plan',       value: w.storage_gb ? `${w.storage_gb} GB · ${w.price_cents ? (w.price_cents / 100).toFixed(2) + ' €/Mo' : ''}` : '—' },
                            { label: 'Laufzeit bis',   value: w.current_period_end ? formatDate(w.current_period_end) : '—' },
                            { label: 'Letzte Rechnung',value: w.last_invoice ? `${w.last_invoice}${w.last_invoice_amount ? ' · ' + (w.last_invoice_amount / 100).toFixed(2) + ' €' : ''}` : '—' },
                            { label: 'Speicher',       value: w.storage_used != null ? `${formatBytes(w.storage_used)} / ${formatBytes(w.storage_limit)} (${storageUsedPct}%)` : '—' },
                            { label: 'Provider',       value: w.provider || '—' },
                          ].map(item => (
                            <div key={item.label}>
                              <div style={{ fontSize: '0.62rem', color: '#8892a4', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{item.label}</div>
                              <div style={{ fontSize: '0.78rem', color: '#e2e8f0', fontWeight: 500, marginTop: '1px', wordBreak: 'break-all' }}>{item.value}</div>
                            </div>
                          ))}
                        </div>
                        {isPending && (
                          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                            <button onClick={() => setConfirmModal({ action: 'approveWithdrawal', withdrawalId: w.id, message: `Widerruf von "${w.username || w.email}" genehmigen? Stripe-Refund wird ausgelöst und Abo gekündigt.` })} className="ap-btn ap-btn--green">✓ Genehmigen + Erstatten</button>
                            <button onClick={() => setRejectWithdrawalModal({ id: w.id, note: '' })} className="ap-btn ap-btn--red">✗ Ablehnen</button>
                          </div>
                        )}
                        {(w.admin_note || w.notes) && (
                          <div style={{ marginTop: '0.5rem', fontSize: '0.72rem', color: '#8892a4', fontStyle: 'italic' }}>
                            Notiz: {w.admin_note || w.notes}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* ── Tab: Meldungen ── */}
          {activeTab === 'reports' && (
            <div>
              {reports.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem 0', color: '#8892a4', fontSize: '0.9rem' }}>Keine Meldungen vorhanden</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                  {reports.map(rep => (
                    <div key={rep.id} className="ap-report-card">
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.75rem', flexWrap: 'wrap' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.3rem', flexWrap: 'wrap' }}>
                            <span style={{ fontWeight: 700, color: '#f87171', fontSize: '0.78rem', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '240px' }}>{rep.link_url || rep.share_token || rep.id}</span>
                            {reportStatusBadge(rep.status || 'open')}
                          </div>
                          <div style={{ fontSize: '0.72rem', color: '#8892a4', lineHeight: 1.7 }}>
                            {rep.reporter && <span style={{ marginRight: '0.75rem' }}>Gemeldet von: <span style={{ color: '#ccc' }}>{rep.reporter}</span></span>}
                            {rep.reason && <span style={{ marginRight: '0.75rem' }}>Grund: <span style={{ color: '#ccc' }}>{rep.reason}</span></span>}
                            <span>{formatDate(rep.created_at)}</span>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '0.4rem', flexShrink: 0, flexWrap: 'wrap' }}>
                          {rep.share_token && (
                            <button onClick={() => window.open(`/share/${rep.share_token}?admin_bypass=true&token=${encodeURIComponent(token)}`, '_blank', 'noopener,noreferrer')} className="ap-btn ap-btn--blue">👁 Prüfen</button>
                          )}
                          {(rep.status === 'open' || !rep.status) && (
                            <>
                              <button onClick={() => handleBlockReport(rep.id)} className="ap-btn ap-btn--red">Sperren</button>
                              <button onClick={() => handleDismissReport(rep.id)} className="ap-btn ap-btn--ghost">Ablehnen</button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ── Tab: Lockdown ── */}
          {activeTab === 'lockdown' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>

              {/* Status Overview */}
              <div className="ap-lockdown-grid">
                <div style={{ background: lockdownStatus?.maintenance_active ? 'rgba(59,130,246,0.08)' : 'rgba(255,255,255,0.03)', border: `1px solid ${lockdownStatus?.maintenance_active ? 'rgba(59,130,246,0.3)' : 'rgba(255,255,255,0.06)'}`, borderRadius: 8, padding: '1rem' }}>
                  <div style={{ fontSize: 11, color: '#4a5568', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>Wartungsmodus</div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: lockdownStatus?.maintenance_active ? '#3B82F6' : '#4a5568' }}>
                    {lockdownStatus?.maintenance_active ? '● AKTIV' : '○ Inaktiv'}
                  </div>
                  {lockdownStatus?.maintenance_active && lockdownStatus?.maintenance_start && (
                    <div style={{ fontSize: 11, color: '#8b95a8', marginTop: 4, fontFamily: 'monospace' }}>seit {new Date(lockdownStatus.maintenance_start).toLocaleString('de-DE')}</div>
                  )}
                  {lockdownStatus?.maintenance_scheduled_start && !lockdownStatus?.maintenance_active && (
                    <div style={{ fontSize: 11, color: '#3B82F6', marginTop: 4, fontFamily: 'monospace' }}>⏰ geplant: {new Date(lockdownStatus.maintenance_scheduled_start).toLocaleString('de-DE')}</div>
                  )}
                </div>
                <div style={{ background: lockdownStatus?.lockdown_active ? 'rgba(239,68,68,0.08)' : 'rgba(255,255,255,0.03)', border: `1px solid ${lockdownStatus?.lockdown_active ? 'rgba(239,68,68,0.3)' : 'rgba(255,255,255,0.06)'}`, borderRadius: 8, padding: '1rem' }}>
                  <div style={{ fontSize: 11, color: '#4a5568', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>System-Lockdown</div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: lockdownStatus?.lockdown_active ? '#ef4444' : '#4a5568' }}>
                    {lockdownStatus?.lockdown_active ? '🔴 AKTIV' : '○ Inaktiv'}
                  </div>
                  {lockdownStatus?.lockdown_active && lockdownStatus?.lockdown_start && (
                    <div style={{ fontSize: 11, color: '#8b95a8', marginTop: 4, fontFamily: 'monospace' }}>seit {new Date(lockdownStatus.lockdown_start).toLocaleString('de-DE')}</div>
                  )}
                </div>
              </div>

              {/* Wartungsmodus */}
              <div className="ap-section-box">
                <div style={{ fontWeight: 600, color: '#f0f2f5', fontSize: 14, marginBottom: '1rem' }}>⚙️ Wartungsmodus</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <div>
                    <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Nachricht</label>
                    <input
                      value={maintenanceForm.message}
                      onChange={e => setMaintenanceForm(f => ({ ...f, message: e.target.value }))}
                      placeholder="Wartungsarbeiten laufen..."
                      className="ap-input"
                    />
                  </div>
                  <div className="ap-form-grid-2">
                    <div>
                      <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Ende (optional)</label>
                      <input
                        type="datetime-local"
                        value={maintenanceForm.end}
                        onChange={e => setMaintenanceForm(f => ({ ...f, end: e.target.value }))}
                        className="ap-input"
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Geplanter Start</label>
                      <input
                        type="datetime-local"
                        value={maintenanceForm.scheduled_start}
                        onChange={e => setMaintenanceForm(f => ({ ...f, scheduled_start: e.target.value }))}
                        className="ap-input"
                      />
                    </div>
                  </div>
                  <div className="ap-lockdown-btns">
                    {!lockdownStatus?.maintenance_active ? (
                      <>
                        <button onClick={handleMaintenanceStart} disabled={lockdownLoading} className="ap-maint-btn">Sofort starten</button>
                        {maintenanceForm.scheduled_start && (
                          <button onClick={handleMaintenanceSchedule} disabled={lockdownLoading} className="ap-maint-btn--ghost">Planen</button>
                        )}
                        {lockdownStatus?.maintenance_scheduled_start && (
                          <button onClick={handleCancelScheduledMaintenance} disabled={lockdownLoading} className="ap-maint-btn--cancel">Geplante Wartung löschen</button>
                        )}
                      </>
                    ) : (
                      <button onClick={handleMaintenanceStop} disabled={lockdownLoading} className="ap-maint-btn--cancel">Wartungsmodus beenden</button>
                    )}
                  </div>
                </div>
              </div>

              {/* Banner */}
              <div className="ap-section-box">
                <div style={{ fontWeight: 600, color: '#f0f2f5', fontSize: 14, marginBottom: '1rem' }}>📢 Dauerhafter Banner</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <input
                    value={maintenanceForm.banner}
                    onChange={e => setMaintenanceForm(f => ({ ...f, banner: e.target.value }))}
                    placeholder="Banner-Text für alle User sichtbar..."
                    className="ap-input"
                  />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13, color: '#8b95a8' }}>
                      <input type="checkbox" checked={maintenanceForm.banner_active} onChange={e => setMaintenanceForm(f => ({ ...f, banner_active: e.target.checked }))} />
                      Banner anzeigen
                    </label>
                    <button onClick={handleBannerUpdate} disabled={lockdownLoading} className="ap-maint-btn">Speichern</button>
                  </div>
                  {lockdownStatus?.maintenance_banner_active && lockdownStatus?.maintenance_banner && (
                    <div style={{ background: 'rgba(59,130,246,0.06)', border: '1px solid rgba(59,130,246,0.2)', borderRadius: 6, padding: '8px 12px', fontSize: 12, color: '#8b95a8' }}>
                      Aktiver Banner: <span style={{ color: '#f0f2f5' }}>{lockdownStatus.maintenance_banner}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* System Lockdown */}
              <div className="ap-section-box" style={{ borderColor: lockdownStatus?.lockdown_active ? 'rgba(239,68,68,0.3)' : undefined }}>
                <div style={{ fontWeight: 600, color: '#ef4444', fontSize: 14, marginBottom: '0.5rem' }}>🔴 System-Lockdown</div>
                <p style={{ fontSize: 12, color: '#4a5568', marginBottom: '1rem', lineHeight: 1.5, margin: '0 0 1rem' }}>
                  Sperrt alle API-Calls von außen. Dein Admin-Zugriff bleibt bestehen. Nutze dies bei kritischen Sicherheitslücken.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <input
                    value={lockdownForm.message}
                    onChange={e => setLockdownForm(f => ({ ...f, message: e.target.value }))}
                    placeholder="Grund der Sperrung..."
                    className="ap-input ap-input--danger"
                  />
                  {!lockdownStatus?.lockdown_active ? (
                    <button onClick={handleLockdownStart} disabled={lockdownLoading} style={{ padding: '8px 16px', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 6, color: '#ef4444', fontSize: 13, fontWeight: 600, cursor: 'pointer', alignSelf: 'flex-start', fontFamily: 'inherit', transition: 'opacity 0.15s' }}>
                      🔴 System-Lockdown aktivieren
                    </button>
                  ) : (
                    <button onClick={handleLockdownStop} disabled={lockdownLoading} style={{ padding: '8px 16px', background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)', borderRadius: 6, color: '#22c55e', fontSize: 13, fontWeight: 600, cursor: 'pointer', alignSelf: 'flex-start', fontFamily: 'inherit', transition: 'opacity 0.15s' }}>
                      ✓ Lockdown beenden
                    </button>
                  )}
                </div>
              </div>

            </div>
          )}

          {/* ── Tab: E-Mail Broadcast ── */}
          {activeTab === 'broadcast' && (() => {
            const categoryOptions = [
              { value: 'announcement', label: 'Ankündigung', color: '#0891b2' },
              { value: 'agb',          label: 'AGB-Aktualisierung', color: '#2563eb' },
              { value: 'datenschutz',  label: 'Datenschutz-Update', color: '#7c3aed' },
              { value: 'maintenance',  label: 'Wartungshinweis', color: '#d97706' },
              { value: 'other',        label: 'Sonstiges', color: '#475569' },
            ];
            const selCategory = categoryOptions.find(c => c.value === broadcastForm.category) || categoryOptions[0];

            const sendBroadcast = async (testMode) => {
              if (!broadcastForm.subject.trim() || !broadcastForm.body.trim()) {
                showToast('Betreff und Text sind Pflichtfelder.', 'error'); return;
              }
              setBroadcastSending(true);
              setBroadcastResult(null);
              try {
                const r = await fetch('/api/admin/broadcast-email', {
                  method: 'POST',
                  headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                  body: JSON.stringify({ ...broadcastForm, testMode }),
                });
                const data = await r.json();
                if (!r.ok) throw new Error(data.error || 'Fehler');
                setBroadcastResult({ ...data, testMode });
                showToast(testMode ? 'Test-E-Mail gesendet!' : `${data.sent} E-Mails gesendet!`, 'success');
              } catch (err) {
                showToast(err.message, 'error');
              } finally {
                setBroadcastSending(false);
                setBroadcastConfirm(false);
              }
            };

            // Inline preview of email
            const previewBody = broadcastForm.body
              .split(/\n{2,}/)
              .map((p, i) => <p key={i} style={{ margin: '0 0 12px', lineHeight: 1.6, color: '#334155', fontSize: 13 }}>{p.split('\n').map((l,j) => <span key={j}>{l}<br/></span>)}</p>);

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

                {/* Form card */}
                <div className="ap-section-box">
                  <div style={{ fontWeight: 700, color: '#f0f2f5', fontSize: 14, marginBottom: '1.25rem' }}>📧 Broadcast E-Mail</div>

                  {/* Row 1: Kategorie */}
                  <div style={{ marginBottom: '0.9rem' }}>
                    <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Kategorie</label>
                    <select
                      value={broadcastForm.category}
                      onChange={e => setBroadcastForm(f => ({ ...f, category: e.target.value }))}
                      className="ap-input"
                      style={{ cursor: 'pointer' }}
                    >
                      {categoryOptions.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                  </div>

                  {/* Row 2: Datum der E-Mail + Gültig ab */}
                  <div className="ap-form-grid-2" style={{ marginBottom: '0.9rem' }}>
                    <div>
                      <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Datum der E-Mail</label>
                      <input
                        type="date"
                        value={broadcastForm.date}
                        onChange={e => setBroadcastForm(f => ({ ...f, date: e.target.value }))}
                        className="ap-input"
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Gültig ab <span style={{ color: '#4a5568', fontWeight: 400 }}>(optional)</span></label>
                      <input
                        type="date"
                        value={broadcastForm.effectiveDate}
                        onChange={e => setBroadcastForm(f => ({ ...f, effectiveDate: e.target.value }))}
                        className="ap-input"
                      />
                    </div>
                  </div>

                  {/* Betreff */}
                  <div style={{ marginBottom: '0.9rem' }}>
                    <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Betreff *</label>
                    <input
                      value={broadcastForm.subject}
                      onChange={e => setBroadcastForm(f => ({ ...f, subject: e.target.value }))}
                      placeholder="z.B. Wichtige Aktualisierung unserer AGB"
                      className="ap-input"
                      maxLength={150}
                    />
                  </div>

                  {/* Text */}
                  <div style={{ marginBottom: '1.25rem' }}>
                    <label style={{ fontSize: 12, color: '#8b95a8', display: 'block', marginBottom: 4 }}>Nachricht *</label>
                    <textarea
                      value={broadcastForm.body}
                      onChange={e => setBroadcastForm(f => ({ ...f, body: e.target.value }))}
                      placeholder={'Schreibe hier den E-Mail-Text...\n\nLeere Zeile = neuer Absatz.'}
                      rows={8}
                      className="ap-input"
                      style={{ resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.6 }}
                    />
                    <div style={{ fontSize: 11, color: '#4a5568', marginTop: 4 }}>{broadcastForm.body.length} Zeichen · Leerzeile = neuer Absatz</div>
                  </div>

                  {/* Buttons */}
                  <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => sendBroadcast(true)}
                      disabled={broadcastSending}
                      style={{
                        flex: 1, minWidth: 140,
                        background: broadcastSending ? 'rgba(217,119,6,0.3)' : 'rgba(217,119,6,0.15)',
                        border: '1px solid rgba(217,119,6,0.4)',
                        color: '#fbbf24', fontWeight: 700, fontSize: 13,
                        padding: '0.65rem 1.25rem', borderRadius: 8, cursor: broadcastSending ? 'not-allowed' : 'pointer',
                        transition: 'all 0.15s',
                      }}
                    >
                      {broadcastSending ? '⏳ Sendet…' : '🧪 Test senden'}
                    </button>
                    <button
                      onClick={() => setBroadcastConfirm(true)}
                      disabled={broadcastSending}
                      style={{
                        flex: 1, minWidth: 140,
                        background: broadcastSending ? 'rgba(239,68,68,0.3)' : 'rgba(239,68,68,0.12)',
                        border: '1px solid rgba(239,68,68,0.35)',
                        color: '#f87171', fontWeight: 700, fontSize: 13,
                        padding: '0.65rem 1.25rem', borderRadius: 8, cursor: broadcastSending ? 'not-allowed' : 'pointer',
                        transition: 'all 0.15s',
                      }}
                    >
                      {broadcastSending ? '⏳ Sendet…' : '📤 An alle senden'}
                    </button>
                  </div>

                  {/* Hinweis Test */}
                  <div style={{ marginTop: '0.75rem', padding: '0.6rem 0.8rem', background: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.12)', borderRadius: 7, fontSize: 11, color: '#8b95a8', lineHeight: 1.5 }}>
                    <strong style={{ color: '#fbbf24' }}>Test:</strong> sendet nur an aquavservices@gmail.com &nbsp;|&nbsp;
                    <strong style={{ color: '#f87171' }}>An alle:</strong> sendet an alle freigeschalteten User mit E-Mail-Adresse
                  </div>
                </div>

                {/* Result */}
                {broadcastResult && (
                  <div style={{ padding: '0.9rem 1rem', background: 'rgba(74,222,128,0.07)', border: '1px solid rgba(74,222,128,0.2)', borderRadius: 9, fontSize: 13, color: '#4ade80' }}>
                    {broadcastResult.testMode
                      ? '✓ Test-E-Mail erfolgreich an aquavservices@gmail.com gesendet.'
                      : `✓ ${broadcastResult.sent} E-Mails gesendet${broadcastResult.skipped > 0 ? ` · ${broadcastResult.skipped} fehlgeschlagen` : ''} (gesamt: ${broadcastResult.total})`
                    }
                  </div>
                )}

                {/* Preview */}
                {(broadcastForm.subject || broadcastForm.body) && (
                  <div className="ap-section-box" style={{ padding: 0, overflow: 'hidden' }}>
                    <div style={{ padding: '0.75rem 1rem', borderBottom: '1px solid rgba(255,255,255,0.06)', fontSize: 12, color: '#8b95a8', fontWeight: 600 }}>Vorschau</div>
                    <div style={{ padding: '1rem', maxHeight: 340, overflowY: 'auto' }}>
                      {/* Mini email mockup */}
                      <div style={{ background: '#0f172a', borderRadius: '8px 8px 0 0', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontWeight: 800, fontSize: 15, color: '#fff' }}>AVS <span style={{ color: '#22d3ee' }}>Cloud</span></span>
                        <span style={{ background: selCategory.color, color: '#fff', fontSize: 10, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', padding: '3px 10px', borderRadius: 20 }}>{selCategory.label}</span>
                      </div>
                      <div style={{ background: '#1e293b', borderLeft: `3px solid ${selCategory.color}`, padding: '12px 16px' }}>
                        <div style={{ fontWeight: 700, color: '#f8fafc', fontSize: 14 }}>{broadcastForm.subject || '(Kein Betreff)'}</div>
                        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 3, display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                          <span>Datum: {new Date(broadcastForm.date || Date.now()).toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
                          {broadcastForm.effectiveDate && (
                            <span style={{ color: '#f8fafc', fontWeight: 600 }}>· Gültig ab: {new Date(broadcastForm.effectiveDate).toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
                          )}
                        </div>
                      </div>
                      <div style={{ background: '#fff', padding: '16px', borderRadius: '0 0 8px 8px' }}>
                        <div style={{ fontSize: 13, color: '#334155', marginBottom: 12, fontWeight: 500 }}>Hallo [Benutzername],</div>
                        {broadcastForm.body ? previewBody : <p style={{ color: '#94a3b8', fontSize: 12 }}>(Noch kein Text eingegeben)</p>}
                        <div style={{ textAlign: 'center', marginTop: 16 }}>
                          <span style={{ display: 'inline-block', background: '#0f172a', color: '#22d3ee', fontWeight: 700, fontSize: 12, padding: '8px 20px', borderRadius: 6, border: '1px solid #22d3ee' }}>Zum Dashboard</span>
                        </div>
                        <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid #e2e8f0', fontSize: 10, color: '#94a3b8', lineHeight: 1.5 }}>
                          AquaV Services · Mert Munz · c/o IP-Management #10553, Ludwig-Erhard-Str. 18, 20459 Hamburg
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            );
          })()}

        </div>
      </div>

      {/* Broadcast Confirm Modal */}
      {broadcastConfirm && (
        <div className="ap-modal-overlay">
          <div className="ap-modal-box" style={{ maxWidth: '420px', border: '1px solid rgba(239,68,68,0.3)' }}>
            <div style={{ fontSize: '1.5rem', textAlign: 'center', marginBottom: '0.75rem' }}>📤</div>
            <p style={{ color: '#fff', fontSize: '0.92rem', fontWeight: 600, marginBottom: '0.5rem', textAlign: 'center', lineHeight: 1.5, margin: '0 0 0.5rem' }}>E-Mail an alle User senden?</p>
            <p style={{ color: '#8892a4', fontSize: '0.8rem', textAlign: 'center', marginBottom: '1.25rem', margin: '0 0 1.25rem', lineHeight: 1.5 }}>
              Betreff: <strong style={{ color: '#dceeff' }}>{broadcastForm.subject}</strong><br/>
              Diese Aktion sendet an <strong style={{ color: '#f87171' }}>alle freigeschalteten User</strong> mit E-Mail-Adresse und kann nicht rückgängig gemacht werden.
            </p>
            <div style={{ display: 'flex', gap: '0.6rem' }}>
              <button onClick={() => setBroadcastConfirm(false)} className="ap-btn ap-btn--ghost ap-btn--full">Abbrechen</button>
              <button
                onClick={() => { setBroadcastConfirm(false); (async () => {
                  if (!broadcastForm.subject.trim() || !broadcastForm.body.trim()) { showToast('Betreff und Text sind Pflichtfelder.', 'error'); return; }
                  setBroadcastSending(true); setBroadcastResult(null);
                  try {
                    const r = await fetch('/api/admin/broadcast-email', { method: 'POST', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ ...broadcastForm, testMode: false }) });
                    const data = await r.json();
                    if (!r.ok) throw new Error(data.error || 'Fehler');
                    setBroadcastResult({ ...data, testMode: false });
                    showToast(`${data.sent} E-Mails erfolgreich gesendet!`, 'success');
                  } catch (err) { showToast(err.message, 'error'); }
                  finally { setBroadcastSending(false); }
                })(); }}
                className="ap-btn ap-btn--red ap-btn--full"
              >Jetzt senden</button>
            </div>
          </div>
        </div>
      )}

      {/* Storage Edit Modal */}
      {editStorageModal && (
        <div className="ap-modal-overlay">
          <div className="ap-modal-box" style={{ maxWidth: '380px', border: '1px solid rgba(0,212,255,0.2)' }}>
            <h3 style={{ color: '#fff', fontWeight: 700, fontSize: '1rem', marginBottom: '0.25rem', margin: '0 0 0.25rem' }}>Speicherlimit anpassen</h3>
            <p style={{ color: '#8892a4', fontSize: '0.8rem', marginBottom: '1.25rem', margin: '0 0 1.25rem' }}>
              {editStorageModal.username} · Aktuell: {formatBytes(editStorageModal.storage_limit)}
            </p>
            <label style={{ display: 'block', fontSize: '0.78rem', color: '#8892a4', marginBottom: '0.4rem' }}>Neues Limit (GB)</label>
            <input
              type="number"
              value={newStorageLimit}
              onChange={e => setNewStorageLimit(e.target.value)}
              placeholder="z.B. 10"
              min="0"
              step="0.1"
              className="ap-input"
              style={{ marginBottom: '0.4rem' }}
            />
            <p style={{ fontSize: '0.72rem', color: '#8892a4', marginBottom: '1.25rem', margin: '0 0 1.25rem' }}>
              = {newStorageLimit ? (parseFloat(newStorageLimit) * 1024).toFixed(0) + ' MB' : '0 MB'}
            </p>
            <div style={{ display: 'flex', gap: '0.6rem' }}>
              <button onClick={() => handleUpdateStorage(editStorageModal.id)} className="ap-btn ap-btn--green ap-btn--full">Speichern</button>
              <button onClick={() => { setEditStorageModal(null); setNewStorageLimit(''); }} className="ap-btn ap-btn--ghost ap-btn--full">Abbrechen</button>
            </div>
          </div>
        </div>
      )}

      {/* User Detail Modal */}
      {userDetailModal && (
        <div className="ap-modal-overlay" onClick={() => setUserDetailModal(null)}>
          <div className="ap-modal-box" style={{ maxWidth: '480px', border: '1px solid rgba(0,212,255,0.15)', maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <h3 style={{ color: '#00d4ff', fontWeight: 700, fontSize: '0.95rem', margin: 0 }}>Benutzerdetails</h3>
              <button onClick={() => setUserDetailModal(null)} style={{ background: 'none', border: 'none', color: '#8892a4', fontSize: '1.1rem', cursor: 'pointer', lineHeight: 1 }}>✕</button>
            </div>

            {/* Basisinfo */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem', padding: '0.75rem', background: 'rgba(255,255,255,0.04)', borderRadius: '8px' }}>
              <img
                src={userDetailModal.avatar ? `https://cdn.discordapp.com/avatars/${userDetailModal.discord_id}/${userDetailModal.avatar}.png` : '/default-avatar.png'}
                alt={userDetailModal.username}
                style={{ width: '44px', height: '44px', borderRadius: '50%', flexShrink: 0 }}
              />
              <div>
                <div style={{ fontWeight: 700, color: '#fff', fontSize: '0.92rem' }}>{userDetailModal.username}</div>
                <div style={{ fontSize: '0.72rem', color: '#8892a4', marginTop: '0.2rem' }}>{userDetailModal.email || 'Keine E-Mail'}</div>
                <div style={{ fontSize: '0.7rem', color: '#8892a4', marginTop: '0.15rem' }}>Status: <span style={{ color: userDetailModal.status === 'blocked' ? '#f87171' : '#4ade80' }}>{userDetailModal.status}</span></div>
              </div>
            </div>

            {/* Infotabelle */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.4rem 1rem', fontSize: '0.75rem', marginBottom: '1rem' }}>
              {[
                ['Registriert', userDetailModal.created_at ? new Date(userDetailModal.created_at).toLocaleDateString('de-DE') : '—'],
                ['Letzter Login', userDetailModal.last_login ? new Date(userDetailModal.last_login).toLocaleDateString('de-DE') : '—'],
                ['Speicher genutzt', userDetailModal.storage_used ? (userDetailModal.storage_used / (1024*1024*1024)).toFixed(2) + ' GB' : '0 GB'],
                ['Speicherlimit', userDetailModal.storage_limit ? (userDetailModal.storage_limit / (1024*1024*1024)).toFixed(2) + ' GB' : '—'],
              ].map(([label, val]) => (
                <div key={label} style={{ background: 'rgba(255,255,255,0.03)', borderRadius: '6px', padding: '0.4rem 0.6rem' }}>
                  <div style={{ color: '#8892a4', marginBottom: '0.15rem' }}>{label}</div>
                  <div style={{ color: '#fff', fontWeight: 600 }}>{val}</div>
                </div>
              ))}
            </div>

            {/* Rechnungsadresse */}
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '0.85rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.6rem' }}>
                <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#c0cad8', textTransform: 'uppercase', letterSpacing: '0.07em' }}>Rechnungsadresse</span>
                {!userDetailAddrEdit && (
                  <button onClick={() => { setUserDetailAddrEdit(true); setUserDetailAddrMsg(''); }} className="ap-btn" style={{ fontSize: '0.72rem', padding: '0.25rem 0.65rem', background: 'rgba(0,212,255,0.1)', color: '#00d4ff', border: '1px solid rgba(0,212,255,0.25)' }}>
                    {userDetailModal.billing_address_set ? 'Ändern' : 'Hinterlegen'}
                  </button>
                )}
              </div>

              {!userDetailAddrEdit ? (
                userDetailModal.billing_address_set ? (
                  <div style={{ fontSize: '0.8rem', color: '#c0cad8', lineHeight: 1.7 }}>
                    {userDetailModal.billing_firstname} {userDetailModal.billing_lastname}<br />
                    {userDetailModal.billing_street}<br />
                    {userDetailModal.billing_zip} {userDetailModal.billing_city}<br />
                    {userDetailModal.billing_country}
                  </div>
                ) : (
                  <div style={{ fontSize: '0.78rem', color: '#8892a4', fontStyle: 'italic' }}>Noch keine Adresse hinterlegt.</div>
                )
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
                  {[
                    ['billing_firstname', 'Vorname', 'text', '1'],
                    ['billing_lastname', 'Nachname', 'text', '1'],
                    ['billing_street', 'Straße & Nr.', 'text', '2'],
                    ['billing_zip', 'PLZ', 'text', '1'],
                    ['billing_city', 'Stadt', 'text', '1'],
                  ].map(([field, label, type, span]) => (
                    <div key={field} style={{ gridColumn: `span ${span}` }}>
                      <label style={{ display: 'block', fontSize: '0.65rem', fontWeight: 600, color: '#8892a4', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: '0.25rem' }}>{label}</label>
                      <input
                        type={type}
                        className="ap-input"
                        style={{ width: '100%', padding: '0.5rem 0.7rem', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '6px', color: '#fff', fontSize: '0.82rem', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' }}
                        value={userDetailAddrForm[field] || ''}
                        onChange={e => setUserDetailAddrForm(f => ({ ...f, [field]: e.target.value }))}
                        disabled={userDetailAddrSaving}
                      />
                    </div>
                  ))}
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ display: 'block', fontSize: '0.65rem', fontWeight: 600, color: '#8892a4', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Land</label>
                    <select
                      className="ap-input"
                      style={{ width: '100%', padding: '0.5rem 0.7rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '6px', color: '#fff', fontSize: '0.82rem', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit', cursor: 'pointer' }}
                      value={userDetailAddrForm.billing_country || 'DE'}
                      onChange={e => setUserDetailAddrForm(f => ({ ...f, billing_country: e.target.value }))}
                      disabled={userDetailAddrSaving}
                    >
                      {[['DE','Deutschland'],['AT','Österreich'],['CH','Schweiz'],['BE','Belgien'],['FR','Frankreich'],['GB','Vereinigtes Königreich'],['IT','Italien'],['NL','Niederlande'],['PL','Polen'],['ES','Spanien'],['SE','Schweden'],['CZ','Tschechien']].map(([code, name]) => (
                        <option key={code} value={code}>{name}</option>
                      ))}
                    </select>
                  </div>
                  {userDetailAddrMsg && (
                    <div style={{ gridColumn: 'span 2', fontSize: '0.78rem', padding: '0.4rem 0.6rem', borderRadius: '5px', ...(userDetailAddrMsg.startsWith('ok') ? { color: '#4ade80', background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.2)' } : { color: '#ff8888', background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.2)' }) }}>
                      {userDetailAddrMsg.replace(/^(ok|err):/, '')}
                    </div>
                  )}
                  <div style={{ gridColumn: 'span 2', display: 'flex', gap: '0.5rem', marginTop: '0.25rem' }}>
                    <button onClick={saveUserBillingAddress} disabled={userDetailAddrSaving} className="ap-btn ap-btn--green" style={{ flex: 1, opacity: userDetailAddrSaving ? 0.5 : 1 }}>
                      {userDetailAddrSaving ? 'Speichert…' : 'Speichern'}
                    </button>
                    <button onClick={() => { setUserDetailAddrEdit(false); setUserDetailAddrMsg(''); }} disabled={userDetailAddrSaving} className="ap-btn ap-btn--ghost" style={{ flex: 1 }}>Abbrechen</button>
                  </div>
                </div>
              )}
              {!userDetailAddrEdit && userDetailAddrMsg && (
                <div style={{ fontSize: '0.78rem', marginTop: '0.5rem', padding: '0.4rem 0.6rem', borderRadius: '5px', ...(userDetailAddrMsg.startsWith('ok') ? { color: '#4ade80', background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.2)' } : { color: '#ff8888', background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.2)' }) }}>
                  {userDetailAddrMsg.replace(/^(ok|err):/, '')}
                </div>
              )}
            </div>

            {/* 2FA Reset */}
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: '1rem', marginTop: '0.5rem' }}>
              <p style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.6rem' }}>
                Zwei-Faktor-Authentifizierung
              </p>
              <button
                onClick={resetUser2FA}
                disabled={reset2FaSaving}
                className="ap-btn ap-btn--red"
                style={{ opacity: reset2FaSaving ? 0.5 : 1, fontSize: '0.82rem', padding: '0.45rem 1rem' }}
              >
                {reset2FaSaving ? 'Setzt zurück…' : '2FA zurücksetzen'}
              </button>
              {reset2FaMsg && (
                <div style={{ fontSize: '0.78rem', marginTop: '0.5rem', padding: '0.4rem 0.6rem', borderRadius: '5px', ...(reset2FaMsg.startsWith('ok') ? { color: '#4ade80', background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.2)' } : { color: '#ff8888', background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.2)' }) }}>
                  {reset2FaMsg.replace(/^(ok|err):/, '')}
                </div>
              )}
            </div>

          </div>
        </div>
      )}

      {/* Confirm Modal */}
      {confirmModal && (
        <div className="ap-modal-overlay">
          <div className="ap-modal-box" style={{ maxWidth: '400px', border: '1px solid rgba(255,255,255,0.1)' }}>
            <p style={{ color: '#fff', fontSize: '0.92rem', fontWeight: 600, marginBottom: '1.5rem', textAlign: 'center', lineHeight: 1.5, margin: '0 0 1.5rem' }}>{confirmModal.message}</p>
            <div style={{ display: 'flex', gap: '0.6rem' }}>
              <button onClick={() => setConfirmModal(null)} className="ap-btn ap-btn--ghost ap-btn--full">Abbrechen</button>
              <button
                onClick={() => {
                  const { action, userId, withdrawalId } = confirmModal;
                  setConfirmModal(null);
                  if (action === 'block') doBlock(userId);
                  else if (action === 'unblock') doUnblock(userId);
                  else if (action === 'delete') doDeleteUser(userId);
                  else if (action === 'approveWithdrawal') handleApproveWithdrawal(withdrawalId);
                }}
                className={`ap-btn ap-btn--full ${confirmModal.action === 'unblock' ? 'ap-btn--green' : 'ap-btn--red'}`}
              >Bestätigen</button>
            </div>
          </div>
        </div>
      )}

      {/* Widerruf Ablehnen Modal */}
      {rejectWithdrawalModal && (
        <div className="ap-modal-overlay">
          <div className="ap-modal-box" style={{ maxWidth: '420px', border: '1px solid rgba(248,113,113,0.3)' }}>
            <h3 style={{ color: '#f87171', fontWeight: 700, fontSize: '1rem', marginBottom: '0.5rem', margin: '0 0 0.5rem' }}>Widerruf ablehnen</h3>
            <p style={{ color: '#8892a4', fontSize: '0.8rem', marginBottom: '1rem', margin: '0 0 1rem' }}>Optionale Begründung (wird dem User per E-Mail mitgeteilt):</p>
            <textarea
              value={rejectWithdrawalModal.note}
              onChange={e => setRejectWithdrawalModal(m => ({ ...m, note: e.target.value }))}
              placeholder="z.B. Widerrufsfrist abgelaufen (14 Tage überschritten)"
              rows={3}
              className="ap-input"
              style={{ resize: 'vertical', marginBottom: '1rem' }}
            />
            <div style={{ display: 'flex', gap: '0.6rem' }}>
              <button onClick={() => setRejectWithdrawalModal(null)} className="ap-btn ap-btn--ghost ap-btn--full">Abbrechen</button>
              <button onClick={() => handleRejectWithdrawal(rejectWithdrawalModal.id, rejectWithdrawalModal.note)} className="ap-btn ap-btn--red ap-btn--full">Ablehnen &amp; E-Mail senden</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default AdminPanel;
